import {
    CartesianGrid,
    Legend,
    Line,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from "recharts";
import PropTypes from "prop-types";
import {Card} from "react-bootstrap";
import {ExportToExcel} from "../ExportToExcel.jsx";
import {CopyDataToClipboard} from "../CopyDataToClipboard.jsx";
import {useSelector} from "react-redux";
import TooltipInfo from "../TooltipInfo.jsx";

export const LineChartAnaliza = ({
                                     data, xDatakey, dataKeys, title, selectors, hideExelExport = false,
                                     hideCopyToclipboard = false, tooltipKey,
                                 }) => {

    const tooltipHtml = useSelector(state =>
        state.chartTooltips.msg[tooltipKey]?.value
    );

    return (
        <Card>
            <Card.Header>
                <div className={'d-flex justify-content-between gap-3'}>
                    <div className={'d-flex justify-content-between'}>
                        <div className={'fs-5'}>
                            {title ?? 'Analiza'}
                        </div>
                        <div>
                            {tooltipHtml && (
                                <TooltipInfo text={tooltipHtml} className="ms-2" />
                            )}
                        </div>
                    </div>
                    <div>
                        {!!selectors && selectors()}
                    </div>
                    <div>
                        {(!hideExelExport && data) &&
                            <ExportToExcel
                                data={data}
                                fileName={title || 'analiza'}
                            />
                        }
                        {(!hideCopyToclipboard && data) &&
                            <CopyDataToClipboard data={data}/>
                        }
                    </div>
                </div>
            </Card.Header>
            <Card.Body>
                <ResponsiveContainer width="100%" height={300}>
                    <LineChart
                        width={500}
                        height={300}
                        data={data}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey={xDatakey}/>
                        <YAxis/>
                        <Tooltip/>
                        <Legend/>
                        {
                            dataKeys.map((dataKey, idx) => (
                                <Line key={idx} type="monotone" dataKey={dataKey.dataKey} stroke={dataKey.color}
                                      activeDot={{r: 8}}/>
                            ))
                        }

                    </LineChart>
                </ResponsiveContainer>
            </Card.Body>
        </Card>
    )
}

LineChartAnaliza.propTypes = {
    data: PropTypes.array.isRequired,
    dataKeys: PropTypes.array.isRequired,
    xDatakey: PropTypes.string.isRequired,
    yDatakey: PropTypes.string.isRequired,
    fill: PropTypes.string,
    title: PropTypes.string,
    colors: PropTypes.array,
    selectors: PropTypes.func,
    hideExelExport: PropTypes.bool,
    hideCopyToclipboard: PropTypes.bool,
    tooltipKey: PropTypes.string,
}
